import { Container, Card, CardContent, Typography } from "@material-ui/core";
import React from "react";
import Content from "../src/privacyPolicy.mdx";
import { PRIVACY_LAST_UPDATE } from "../src/privacyPolicyVersions";
import styles from "../src/markdown.module.css";
import { withDefaultLayout } from "../src/layout/layout";

export default withDefaultLayout(function PrivacyPolicy() {
  return (
    <Container maxWidth="md" disableGutters>
      <Card>
        <CardContent>
          <Typography variant="h4" component="h1">
            Hinweise zum Datenschutz
          </Typography>
          <Typography>
            Stand: <span>{PRIVACY_LAST_UPDATE}</span>
          </Typography>
          <div className={styles.tos}>
            <Content />
          </div>
        </CardContent>
      </Card>
    </Container>
  );
});
